import { render, staticRenderFns } from "./Header_2.vue?vue&type=template&id=ec7f1fc0&scoped=true&"
import script from "./Header_2.vue?vue&type=script&lang=js&"
export * from "./Header_2.vue?vue&type=script&lang=js&"
import style0 from "./Header_2.vue?vue&type=style&index=0&id=ec7f1fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7f1fc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
